module.exports = __webpack_public_path__ + "img/菜刀.984d90b0.gif";